/**
 * Shared timbre profiles for the audio engine.
 * Centralizes ADSR, Filter, and Reverb settings for consistency across modes.
 */
export const TIMBRE_PRESETS = {
    // Large, resonant, produced sound (Composer Chorus/Finale, Timeless Mode)
    MAJESTIC: {
        filter: 0.8,
        release: 2.5,
        reverb: 0.65
    },
    // Intimate, drier sound (Composer Verse)
    INTIMATE: {
        filter: 0.4,
        release: 0.8,
        reverb: 0.4
    },
    // Urgent, tighter sound (Composer Bridge/Tension)
    URGENT: {
        filter: 0.6,
        release: 1.5,
        reverb: 0.6
    },
    // Massive, anthemic sound (Composer Chorus)
    ANTHEMIC: {
        filter: 0.8,
        release: 2.0,
        reverb: 0.7
    }
};
